import React from 'react';
import { faCircle, faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type status_color = {
  [key: string]: string;
};

const status_colors: status_color = {
  ok: '#5eba00',
  error: '#fa4654',
  disabled: '#9e9e9e',
};
type StatusIconProps = {
  enabled: boolean;
  error: boolean;
};

export default function StatusIcon({ enabled, error }: StatusIconProps) {
  const getStatusColor = () => {
    if (error) return status_colors.error;
    if (enabled) return status_colors.ok;
    return status_colors.disabled;
  };

  const getMarginClass = () => {
    return enabled && !error ? 'mr-2' : 'mr-1';
  };

  return (
    <span className="w-8 h-[22px] relative m-0">
      <FontAwesomeIcon
        icon={faHistory}
        size="lg"
        className={getMarginClass()}
      />
      <div className="absolute -bottom-1 right-3">
        <FontAwesomeIcon
          icon={faCircle}
          color={getStatusColor()}
          style={{ fontSize: 8 }}
        />
      </div>
    </span>
  );
}
